import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface OfferFiltersState {
  startRange: Dayjs | null;
  endRange: Dayjs | null;
  isButterflyEffect: boolean;
  isCancellationPolicy: boolean;
  tags: string[];
  groups: string[];
  status: string;
  offerType: string;
  eventType: string;
  memberPrice: string;
  nonMemberPrice: string;
  popularOffer: boolean;
  selectedTagsId: string[];
  selectedGroupsId: string[];
}

const initialState: OfferFiltersState = {
  startRange: null,
  endRange: null,
  isButterflyEffect: false,
  isCancellationPolicy: false,
  tags: [],
  groups: [],
  status: "",
  offerType: "",
  eventType: "",
  memberPrice: "",
  nonMemberPrice: "",
  popularOffer: false,
  selectedTagsId: [],
  selectedGroupsId: [],
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("offerFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
    }
  : initialState;

const offerFiltersSlice = createSlice({
  name: "offerFilters",
  initialState: persistedState,
  reducers: {
    setOfferFilters(state, action: PayloadAction<Partial<OfferFiltersState>>) {
      Object.assign(state, action.payload);
      localStorage.setItem("offerFilters", JSON.stringify(state));
    },
    resetOfferFilters() {
      localStorage.removeItem("offerFilters");
      return initialState;
    },
  },
});

export const { setOfferFilters, resetOfferFilters } = offerFiltersSlice.actions;

export default offerFiltersSlice.reducer;
